module.exports = __webpack_public_path__ + "static/img/index_toujiao1.f492221.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_toujiao1.jpg
// module id = NDI4
// module chunks = 1